module.exports = __webpack_public_path__ + "img/pay_fingerprint.91cbde90.svg";